import { TextMaskModule } from 'angular2-text-mask';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DynamicInputComponent} from './dynamic-input/dynamic-input.component';
import {InputTextComponent} from './input-text/input-text.component';
import {MatInputModule} from '@angular/material/input';
import {NgxMaskModule} from 'ngx-mask';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {InputDateComponent} from './input-date/input-date.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {InputDropdownComponent} from './input-dropdown/input-dropdown.component';
import {MatSelectModule} from '@angular/material/select';
import {NgxCurrencyModule} from 'ngx-currency';
import {NgSelectModule} from '@ng-select/ng-select';
import {FocusDirective} from './util/focus.directive';
import {NumericKeyboardDirective} from './util/numericKeyboard.directive';
import {TrimDirective} from './util/trim.directive';
import {InputCheckboxComponent} from './input-checkbox/input-checkbox.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { ImageCaptureInputModule } from '../image-capture-input.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InputOtpComponent } from './input-otp/input-otp.component';

@NgModule({
  declarations: [
    DynamicInputComponent,
    InputTextComponent,
    InputDateComponent,
    InputDropdownComponent,
    FocusDirective,
    NumericKeyboardDirective,
    TrimDirective,
    InputCheckboxComponent,
    InputOtpComponent
  ],
  exports: [
    DynamicInputComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskModule.forRoot(),
    MatButtonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    NgxCurrencyModule,
    NgSelectModule,
    FormsModule,
    MatCheckboxModule,
    ImageCaptureInputModule,
    MatProgressSpinnerModule,
    TextMaskModule
  ]
})
export class DynamicInputsModule {
}
